/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An authentication header required by the MCP server
 */
export type McpExportAuthHeader = {
  /**
   * User-friendly display name (e.g., API Key)
   */
  displayName: string;
  /**
   * The HTTP header name (e.g., Authorization)
   */
  name: string;
};

/** @internal */
export const McpExportAuthHeader$inboundSchema: z.ZodMiniType<
  McpExportAuthHeader,
  unknown
> = z.pipe(
  z.object({
    display_name: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
    });
  }),
);

export function mcpExportAuthHeaderFromJSON(
  jsonString: string,
): SafeParseResult<McpExportAuthHeader, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => McpExportAuthHeader$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'McpExportAuthHeader' from JSON`,
  );
}
